export default {
    intro: `Xem chủ đề viết và viết bài của riêng bạn.<br />
            Đọc bài của bạn bè và bỏ phiếu cho bài bạn thích nhé.`,
    buttons: { cancel: 'Hủy', submit: 'Nộp bài' },
    options: {
        timer: { title: 'Cài đặt hẹn giờ', inputTime: 'Thời gian viết', voteTime: 'Thời gian bỏ phiếu' },
        example: { title: 'Hiển thị mẫu câu trả lời', description: 'Mẫu câu trả lời sẽ hiển thị trên màn hình của Học sinh.' },
        votesPerStudent: { title: 'Cài đặt số phiếu bầu cho mỗi Học sinh' },
    },
    noTitleCard: 'Thẻ không có tiêu đề',
    noContentCard: 'Thẻ không có nội dung',
    exampleAnswer: 'Mẫu câu trả lời',
    tabs: { check: '1. Xem chủ đề viết', write: '2. Viết thẻ', vote: '3. Tiến hành bỏ phiếu', result: '4. Kết quả bỏ phiếu' },
    tabStudent: {
        write: 'Hãy xem chủ đề viết và viết ý kiến của bạn.',
        previousVote: 'Hãy đọc bài viết của bạn bè trước khi bỏ phiếu.',
        vote: 'Hãy bỏ phiếu cho bài viết bạn thích.',
        result: 'Hãy xem bài viết được bạn bè yêu thích nhất!',
    },
    card: { title: 'Bạn chưa viết tiêu đề 😶', content: 'Bạn chưa viết nội dung nào 😵' },
    cardWritingArea: {
        titlePlaceholder: 'Hãy nhập tiêu đề. (khoảng 30 ký tự)',
        contentPlaceholder: 'Hãy nhập nội dung. ',
        unsubmittedStudents: 'Chưa nộp {count} người',
    },
    loading: { voteStart: 'Bắt đầu bỏ phiếu', voteResult: 'Đang tổng hợp phiếu bầu', readNext: 'Đang chuẩn bị chủ đề viết tiếp theo' },
    vote: { selfVote: 'Bạn không thể bỏ phiếu cho chính mình.', voteLimit: 'Bạn đã sử dụng hết số phiếu bầu.' },
    student: {
        inPlay: {
            readyText: `Hãy xem chủ đề viết và<br />nghĩ xem bạn sẽ viết gì nhé.`,
            topic: 'Chủ đề viết',
            foldTopic: 'Thu gọn chủ đề',
            imageAlt: 'Tài liệu hình ảnh',
            voteRemaining: 'Còn {count} phiếu',
            waiting: 'Đang chờ',
        },
        toast: {
            contentLengthWarning: 'Nội dung không quá 2.000 ký tự.',
            titleLengthWarning: 'Vui lòng viết tiêu đề trong vòng 30 ký tự.',
            inputEndWarning: 'Còn 15 giây. Thời gian viết sắp kết thúc.',
            voteEndWarning: 'Còn 15 giây. Cuộc bỏ phiếu sắp kết thúc.',
        },
    },
    teacher: {
        setting: {
            titlePlaceholder: 'Vui lòng nhập tiêu đề chủ đề viết. (Tối đa 200 ký tự)',
            textPlaceholder: 'Vui lòng nhập mô tả chủ đề viết. (Tối đa 1.000 ký tự)',
            inputErrorMessage: 'Vui lòng nhập',
            delete: 'Xóa', register: 'Lưu', cancel: 'Hủy',
            addQuestion: 'Thêm chủ đề viết',
        },
        inPlay: {
            readyTextInput: `Sau khi giải thích chủ đề viết, <br />
                                    hãy nhấn 'Bắt đầu viết'`,
            readyTextSubmit: `Khi Học sinh nộp bài, <br />
                                    sẽ hiển thị ở đây.`,
        },
        modal: {
            title: 'Viết thẻ 💬',
            startConfirm: {
                message: 'Có nội dung đang được viết để thêm chủ đề viết.',
                subMessage: 'Nếu bắt đầu hoạt động ngay bây giờ, tất cả nội dung đã viết sẽ bị xóa và không được thêm vào câu hỏi.',
                optionalMessage: 'Vẫn muốn bắt đầu hoạt động?',
                confirmText: 'Bắt đầu hoạt động', cancelText: 'Tiếp tục viết',
            },
            voteStart: {
                message: 'Còn Học sinh đang viết bài.',
                subMessage: 'Bạn có muốn nộp thẻ và bắt đầu bỏ phiếu không?',
                confirmText: 'Bắt đầu bỏ phiếu',
            },
            voteEnd: {
                message: 'Thời gian bỏ phiếu đã kết thúc.',
                subMessage: 'Bạn có muốn xem kết quả không?',
                confirmText: 'Xem kết quả',
            },
            questionDelete: {
                message: 'Bạn có muốn xóa chủ đề viết không?',
                subMessage: 'Chủ đề viết đã xóa không thể khôi phục.',
                confirmText: 'Xóa',
            },
        },
        button: {
            step: {
                beforeStart: 'Bắt đầu viết', writingEnd: 'Kết thúc viết',
                voteEnd: 'Kết thúc bỏ phiếu', nextTopic: 'Chủ đề viết tiếp theo', activityStart: 'Bắt đầu hoạt động',
            },
        },
        result: { topic: 'Chủ đề viết' },
    },
};
